/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import getPropStylesFactory from 'lib/utils/getPropStylesFactory';
import getComponentStylesFactory from 'lib/utils/getComponentStylesFactory';
import getComponentThemeFactory from 'lib/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "button": {},
  "modal_variant_default": "",
  "modal_colors_default": "[&::backdrop]:bg-black/50",
  "modal_size_default": "p-0",
  "variant_default": "text-center",
  "colors_default": "",
  "size_default": ""
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "SaveArticleButton");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;